import { FC, ReactNode, useMemo } from 'react'
import cn from 'classnames'
import styles from 'components/features/external/ExternalLayout/ExternalLayout.styl'
import ExternalHeader from 'components/features/external/ExternalHeader/ExternalHeader'
import ExternalFooter from 'components/features/external/ExternalFooter/ExternalFooter'
import { IS_STATUS_APP } from 'helpers/userAgentHelpers'
import withReadyEvent from 'hocs/withReadyEvent/withReadyEvent'
import ExternalStickyHeaderContainer from 'components/features/external/ExternalStickyHeader/ExternalStickyHeaderContainer'
import { HeaderTheme } from 'interfaces/component'

type ExternalLayoutProps = {
  type: 'common' | 'homepage' | 'feed' | 'advisor'
  isSingleColumn?: boolean
  noStickyHeader?: boolean
  noFooter?: boolean
  announcementNode?: ReactNode
  headerNode?: ReactNode
  footerNode?: ReactNode
  wide?: boolean
  contentClassName?: string
}

export const ExternalLayoutComponent: FC<ExternalLayoutProps> = (props) => {
  const { type, isSingleColumn, announcementNode, headerNode, noStickyHeader, children, wide, noFooter, contentClassName, footerNode } = props
  const headerTheme: HeaderTheme = 'light'
  const typeClassName = styles[type]
  const modifiersClassName = cn(typeClassName, {
    [styles.wide]: !!wide,
    [styles.singleColumn]: isSingleColumn,
  })

  const externalStickyHeader = IS_STATUS_APP || noStickyHeader
    ? null
    : (
      <ExternalStickyHeaderContainer theme={ headerTheme } />
    )

  const footerChild = useMemo(() => {
    if (footerNode) {
      return footerNode
    }

    if (IS_STATUS_APP || noFooter) {
      return null
    }

    return (
      <ExternalFooter />
    )
  }, [footerNode, noFooter])

  return (
    <section className={ cn(styles.externalLayout, modifiersClassName) }>
      { externalStickyHeader }
      { announcementNode }
      { headerNode !== null && (
        <div className={ styles.headerWrapper }>
          { headerNode || (
            <ExternalHeader
              theme={ headerTheme }
              hasExternalNavigation={ !IS_STATUS_APP }
              hasLoginButton={ !IS_STATUS_APP }
              hasJoinButton={ !IS_STATUS_APP }
              isSticky={ false }
            />
          )}
        </div>
      )}
      <main className={ cn(styles.main, contentClassName) }>
        { children }
      </main>
      { footerChild }
    </section>
  )
}

const ExternalLayout = withReadyEvent(ExternalLayoutComponent)

export default ExternalLayout
